import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';
import AuthClassicLayout from 'src/layouts/auth/classic';
import PreAuthVersionGuard from 'src/auth/guard/pre-auth-version-guard';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/login'));
const CompanionLoginPage = lazy(() => import('src/pages/auth/companion-login'));
const V3DeviceLoginPage = lazy(() => import('src/pages/auth/v3-device-login'));


// ----------------------------------------------------------------------

export const authRoutes = [{
  path: 'auth',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: 'login',
      element: (
        <PreAuthVersionGuard>
          <GuestGuard>
            <AuthClassicLayout>
              <JwtLoginPage />
            </AuthClassicLayout>
          </GuestGuard>
        </PreAuthVersionGuard>
      ),
    },
    {
      path: 'login-companion',
      element: (
        <PreAuthVersionGuard>
          <GuestGuard>
            <CompanionLoginPage />
          </GuestGuard>
        </PreAuthVersionGuard>
      ),
    },
    {
      path: 'v3-device-login',
      element: (
        <PreAuthVersionGuard>
          <GuestGuard>
            <AuthClassicLayout>
              <V3DeviceLoginPage />
            </AuthClassicLayout>
          </GuestGuard>
        </PreAuthVersionGuard>
      ),
    },

    // {
    //   element: (
    //     <CompactLayout>
    //       <Outlet />
    //     </CompactLayout>
    //   ),
    //   children: [
    //     { path: 'verify', element: <FirebaseVerifyPage /> },
    //     { path: 'forgot-password', element: <FirebaseForgotPasswordPage /> },
    //   ],
    // },
  ],
}];
